<template>
  <div class="index-container">
    <img src="/static/images/welcome1.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'index',
  components: {},
  data () {
    return {}
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.index-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(120deg, #37b3a7, #025166);
  // background: url("/static/images/map.png") no-repeat center;
  // background-size: auto;
  img {
    width:100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/welcome/index.vue